import { createSlice } from "@reduxjs/toolkit";

import { fetchTimeInStage } from "./actions";

export const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const DEFAULT_ERROR = "Failed to load time in stage";

const timeInStageSlice = createSlice({
  name: "timeInStage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTimeInStage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTimeInStage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchTimeInStage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default timeInStageSlice.reducer;
